import React, { useState, useEffect, useCallback } from "react";
import Header from "./header/header";
import Footer from "./Footer";
import "./Handsonexperience.css";
import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import { Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import { usePaystackPayment } from "react-paystack";
import { baseUrl, GetToken, getUserCountry } from "../App";
import { loadStripe } from "@stripe/stripe-js";
import { ClipLoader } from "react-spinners";
import { BsEmojiFrown } from "react-icons/bs";
import { generateReceipt } from "./generatePaymentReceipt";
import { useUsers } from "./Contexts/UsersContext";
import { useAlert } from "./Contexts/AlertContext";



const Handsonform: React.FC = () => {
  const [ready, setReady] = useState(false);
  const [careerpath, setCareerpath] = useState<any>([]);
  const [careerprice, setCareerprice] = useState("");
  const [showprice, setShowprice] = useState(false);
  const [handName, setHandName] = useState("");
  const [handEmail, setHandEmail] = useState("");
  const [inputphone, setInputphone] = useState("");
  const [disablebutton, setDisablebutton] = useState(false);
  const [careername, setCareername] = useState("");
  const [showcarerror, setShowcarerror] = useState(false);
  const [isNigerianIP, setIsNigerianIp] = useState(true);
  const [showPaybutton, setShowPaybutton] = useState(false);
  const [payablePrice, setPayablePrice] = useState(0);
  const [price, setPrice] = useState(0);
  const [currencyName, setCurrencyName] = useState("");
  const [authUser, setAuthUser] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [authEmail, setAuthEmail] = useState<string | null>();
  const [sCareerPathList, setSCareerPathList] = useState<any>([])
  const [sCareerPriceList, setSCareerPriceList] = useState<any>([])
  const [careerValue, setCareerValue] = useState<string>("")
  const { showAlert } = useAlert();
  const { User } = useUsers();
  // Function to get error message based on error type
  const getErrorMessage = (error: any) => {
    if (!error.response) {
      return "Network Error: Unable to connect to the server. Please check your internet connection.";
    }
    const statusCode = error.response.status;
    switch (statusCode) {
      case 500:
        return "Oops, there is a slight issue with our server, please refresh or try again in a moment.";
      case 400:
        return "Sorry, our server cannot process your input. Please confirm your input.";
      case 403:
        return "You do not have permission to access this resource.";
      case 404:
        return "Your requested resource could not be found on the server.";
      default:
        return `Error ${statusCode}: An error occurred. Please try again later.`;
    }
  };

  useEffect(() => {
    if (localStorage.getItem("handsonexpFormInfo") &&  localStorage.getItem("handsonexpEmailToUser")
           &&   localStorage.getItem("handsonexpEmailToDoyen")) {

      localStorage.removeItem("handsonexpFormInfo")
      localStorage.removeItem("handsonexpEmailToUser")
      localStorage.removeItem("handsonexpEmailToDoyen")
    }
  }, [])

  const handleModalClose = () => {
    setShowModal(false);
    setModalContent(""); // Reset modal content
  };

  let navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (!user) {
        setAuthUser(false);
        navigate("/signin", { state: { from: location.pathname } });
        return;
      } else {
        if (localStorage.getItem("doyenifyacademytwitterUid")) {
          setAuthUser(true);
          setAuthEmail(user?.email);
        } else if (user?.emailVerified === true) {
          setAuthUser(true);
          setAuthEmail(user?.email);
        } else {
          setAuthUser(false);
          navigate("/signin", { state: { from: location.pathname } });
        }
      }
    });
  }, [authUser, navigate, location.pathname]);

  const getCareerpathcost = useCallback(async () => {
    try {
      const idToken = await GetToken();
      const responsecareerpath = await axios.get(
        `${baseUrl}/careerpath`,
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        }
      );

      const careerpathData = responsecareerpath.data;

      let careerPathList:any = []
      let careerPriceList:any = []
      careerpathData.forEach((item:any) => {
        careerPathList.push(item.Careerpath)
        careerPriceList.push(item.price)
      })

      setSCareerPathList(careerPathList)
      setSCareerPriceList(careerPriceList)
                                        
      setCareerpath(careerpathData);
    } catch (error) {
      console.error("error fetching career path data", error);
      setShowModal(true);
      setModalContent(getErrorMessage(error));
    }
  }, []);

  const handleCareerpathClick = async (name: string, price: any) => {
    setHandName(User?.firstname + " " + User?.lastname)
    setHandEmail(String(User?.email))
    setInputphone(String(User?.phone))
    const userDetails2 = await getUserCountry();
    setCareername(name);
    let tempSaver: string = "";

    let userDetails: any
    if (userDetails2.continentCode === "EU") {
      userDetails = {
        continentCode: "EU",
        countryCode: "FR"
      }
    } else {
      userDetails = {
        continentCode: "NA",
        countryCode: "US"
      }
    }
    
    switch (userDetails.continentCode) {
      case "EU":
        if (userDetails.countryCode === "GB") {
          tempSaver = "£" + String(price.priceInPounds);
          setPrice(price.priceInPounds);
          setCurrencySymbol("£");
          setCareerprice(tempSaver);
          setIsNigerianIp(false);
          setCurrencyName("gbp");
          setPayablePrice(price.priceInPounds);
        } else {
          tempSaver = "€" + String(price.priceInEuros);
          setPrice(price.priceInEuros);
          setCurrencySymbol("€");
          setCareerprice(tempSaver);
          setIsNigerianIp(false);
          setCurrencyName("eur");
          setPayablePrice(price.priceInEuros);
        }
        break;
      case "AF":
        if (userDetails.countryCode === "NG") {
          tempSaver = "NGN" + String(price.priceInNaira) + "K";
          setPrice(price.priceInNaira * 1000);
          setCareerprice(tempSaver);
          setCurrencyName("Naira");
          setCurrencySymbol("₦");
          setPayablePrice(price.priceInNaira * 1000);
        } else {
          tempSaver = "$" + String(price.priceForOtherAfricans);
          setPrice(price.priceForOtherAfricans);
          setCareerprice(tempSaver);
          setIsNigerianIp(false);
          setCurrencyName("usd");
          setCurrencySymbol("$");
          setPayablePrice(price.priceForOtherAfricans);
        }
        break;
      default:
        tempSaver = "$" + String(price.priceInDollars);
        setPrice(price.priceInDollars);
        setCareerprice(tempSaver);
        setCurrencyName("usd");
        setCurrencySymbol("$");
        setIsNigerianIp(false);
        setPayablePrice(price.priceInDollars);
    }
    setShowprice(true);
  };

  const loadings = () => {
    new Promise((r) => setTimeout(r, 100));
    setReady(true);
  };

  useEffect(() => {
    getCareerpathcost();
    loadings();
  }, [getCareerpathcost]);

  

  const submitWebinarform = async () => {
    console.log("Entered here");
    let idToken = await GetToken();

    // Proceed only if showprice is true and phone number is valid
    if (showprice === true && inputphone.length > 6) {
      try {
        const responsehandsonexp = await axios.get(
          `${baseUrl}/handsonexp`,
          {
            headers: {
              Authorization: `Bearer ${idToken}`,
            },
          }
        );

        const dataexp = responsehandsonexp.data;
        const detailsExist = dataexp.some(
          (request: any) =>
            request.Email === handEmail && request.Careerpath === careername
        );
        if (detailsExist) {
          console.log("If");
          showAlert("You have already applied!!!", "warning");
        } else {
          console.log("Else");
          setShowPaybutton(true);
        }
      } catch (error) {
        console.error("Error fetching hands-on experience data", error);
        setShowModal(true);
        setModalContent(getErrorMessage(error));
      }
    }
  };

  const makepayment = async () => {

    if (showprice === false) {
      setShowcarerror(true);
    } else {
      setShowcarerror(false);
    }

    if (showprice === true && inputphone.length > 6) {
      setDisablebutton(true);

      const HandsonexperienceFormData = {
        Name: handName.trim(),
        Email: handEmail.trim(),
        Phone: inputphone.trim(),
        Careerpath: careername.trim(),
        Price: price,
        Status: "Approved",
        paymentCurrency: currencySymbol.trim(),
      };

      let userDetails2 = await getUserCountry();

      let userDetails: any
      if (userDetails2.continentCode === "EU") {
        userDetails = {
          continentCode: "EU",
          countryCode: "FR"
        }
      } else {
        userDetails = {
          continentCode: "NA",
          countryCode: "US"
        }
      }
    
      let paymentPrice = 0
      let currency = "";
      switch (userDetails.continentCode) {
        case "EU":
          currency="€";
          paymentPrice = 300;
          break;
        case "AF":
          if (userDetails.countryCode === "NG") {
            currency="₦";
            paymentPrice = 200000;
          } else {
            currency="$";
            paymentPrice = 200;
          }
          break;
        default:
          currency="$";
          paymentPrice = 346;
      }

      let generatedReceipt = await generateReceipt(
        handName,
        "",
        handEmail,
        careername,
        "full",
        currency,
        0,
        paymentPrice,
        paymentPrice,
        paymentPrice,
      );
      const  uint8ArrayToBase64=(uint8Array:any) => {
        let binaryString = '';
        for (let i = 0; i < uint8Array.byteLength; i++) {
          binaryString += String.fromCharCode(uint8Array[i]);
        }
        return btoa(binaryString);
      }
      const base64Content = uint8ArrayToBase64(generatedReceipt);

      const bodytouser = {
        sender: {
          name: "Doyenify Academy",
          email: "info@doyenify.com",
        },
        to: [
          {
            email: handEmail,
          },
        ],
        replyTo:{
          email:"info.doyenify@gmail.com",
        },
        subject: "Confirmation: Registration for {{params.careername}}",
        htmlContent: `<html><head>
        
                    <style>
                        body {
                            background-color:#696969;
                        }
                        .imgtag{
                            justify-content: center;
                            align-items: center;
                            margin-left: 45%;
                        }
                        .welcome {
                            text-align: center;
                            color: #696969;
                        }
                
                        .content {
                            background-color: #ffffff;
                            margin: 15px;
                            padding: 20px;
                        }
                    </style>
                </head>
                
                <body>
                    <div className="imgtag">
                        <img src="https://academy.doyenify.com/images/doyenifyAcademy.png" alt="img" /> 
                    </div>
                    
                    <div className="content">
                        <p>Dear {{params.username}},</p> 
                        <p style="margin-bottom: 10px">We are delighted to inform you that your registration for the {{params.careername}} has been successfully processed. Welcome to our service!</p>

                        
                        <p>We are excited to have you as a participant, and we believe that you will find this service both useful and engaging. Whether you are looking to enhance your skills, explore new opportunities, we are confident that this service will meet your expectations.</p>

                        


                        <p>If you have any questions, please don't hesitate to reach out to our support team at info.doyenify@gmail.com .</p>
                        
                        <p>Thank you once again for choosing Us.</p>

                        <p>Best regards,</p>  
                        <p>DoyenifyAcademy</p>
                    </div>
                
                    
                </body>
                </html>
                                
                            `,
        params: {
          careername: careername,
          username: handName,
        },
        attachment: [
          {
            name: "Payment Receipt.pdf",
            content: base64Content,
          },
        ],
      };

      const bodytodoyen = {
        sender: {
          name: "Doyenify Academy Notification",
          email: "info@doyenify.com",
        },
        to: [
          {
            email: "info.doyenify@gmail.com",
          },
        ],
        replyTo:{
          email:"info.doyenify@gmail.com",
        },
        subject:
          "Someone registered for handsonexperience service '{{params.careername}}'",
        htmlContent: `<html><head></head><body>
                                <h1>you have a newly registered user for the Handsonexperience program</h1>
                                <p>Course Name: {{params.careername}}</p>
                                <p>Course Price: {{params.price}}</p>
                                <p>Person's Name: {{params.name}}, registered</p>
                                <p>Person's Email: {{params.email}}</p>
                                <p>Person's Phone Number: {{params.phone}}</p>
                                
                                
                            </body></html>`,
        params: {
          careername: careername,
          price: careerprice,
          email: handEmail,
          phone: inputphone,
          name: handName,
        },
        attachment: [
          {
            name: "Payment Receipt.pdf",
            content: base64Content,
          },
        ],
      };

     
        localStorage.setItem("handsonexpFormInfo", JSON.stringify(HandsonexperienceFormData))

        localStorage.setItem("handsonexpEmailToUser", JSON.stringify(bodytouser))
        localStorage.setItem("handsonexpEmailToDoyen", JSON.stringify(bodytodoyen))

    }
  };

  //PAYMENT

  // Define onSuccess function
  const onSuccess = () => {
    makepayment();
    setShowPaybutton(false);
    navigate("/enrollformsuccess");
  };
  // Define onClose function
  const onClose = () => {
    console.log("closed");
    navigate("/enrollformcancel");
  };

  var publickey: any = process.env.REACT_APP_PAYSTACKPUBLIC_KEY;

  const PaystackHookExample = () => {
    const paystackConfig = {
      reference: new Date().getTime().toString(),
      email: authEmail || "",
      amount: payablePrice * 100, // Amount is in the country's lowest currency. E.g Kobo, so 20000 kobo = N200
      publicKey: publickey,
    };

    const initializePayment = usePaystackPayment(paystackConfig);

    return (
      <div>
        <div
          style={{
            backgroundColor: "#e3f8e7",
            height: "50px",
            borderRadius: "20px",
            marginTop: "10px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => {
            initializePayment(onSuccess, onClose);
          }}
        >
          <img
            style={{ marginLeft: "15%", padding: "10px", height: "50px" }}
            src="../../images/paystacklogo.png"
            alt="Paystack logo"
          />
        </div>
      </div>
    );
  };

  // const makePaymentWithStripe = async () => {
  //   const stripe: any = await loadStripe(
  //     String(process.env.REACT_APP_STRIPEPK_LIVEKEY)
  //   );

  //   const body = {
  //     packages: [
  //       {
  //         program: "Course Payment",
  //         name: careername,
  //         price: String(payablePrice),
  //         image:
  //           "https://st.depositphotos.com/2890953/4530/i/950/depositphotos_45303419-stock-photo-books-and-graduation-cap.jpg",
  //         currency: String(currencyName),
  //       },
  //     ],
  //     successUrl: process.env.REACT_APP_API_STRIPE_SUCCESS_URL,
  //     cancelUrl: process.env.REACT_APP_API_STRIPE_FAILURE_URL,
  //   };

  //   const headers = {
  //     "Content-Type": "application/json",
  //   };

  //   const response = await fetch(
  //     `${baseUrl}/create-checkout-session`,
  //     {
  //       method: "POST",
  //       headers: headers,
  //       body: JSON.stringify(body),
  //     }
  //   );

  //   const session = await response.json();
  //   const result = stripe.redirectToCheckout({
  //     sessionId: session.id,
  //   });
  //   localStorage.setItem("sessiontrackidss", session.id);
  //   localStorage.setItem("installmentpresent", "false");
  //   makepayment();
  //   if (result.error) {
  //     console.log(result.error);
  //   }
  // };

    // const checkIfCareerIsChosen = (e: React.FormEvent<HTMLFormElement>) => {
    //   e.preventDefault();
    //   if (careername.length < 1) {
    //     toast("Please choose a career path first");
    //   } else {
    //     handleSubmit(submitWebinarform)();
    //   }
    // };

    const makePaymentWithStripe = async () => {
  setDisablebutton(true);
  try {
    const stripe: any = await loadStripe(String(process.env.REACT_APP_STRIPEPK_LIVEKEY));

    const body = {
      packages: [
        {
          program: "Course Payment",
          name: careername,
          price: String(payablePrice),
          image: "https://st.depositphotos.com/2890953/4530/i/950/depositphotos_45303419-stock-photo-books-and-graduation-cap.jpg",
          currency: String(currencyName),
        },
      ],
      successUrl: process.env.REACT_APP_API_STRIPE_SUCCESS_URL,
      cancelUrl: process.env.REACT_APP_API_STRIPE_FAILURE_URL,
    };

    const response = await fetch(`${baseUrl}/create-checkout-session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    const session = await response.json();

    // Write everything BEFORE leaving the page
    await makepayment();
    localStorage.setItem("sessiontrackidss", session.id);
    localStorage.setItem("installmentpresent", "false");


    const result = await stripe.redirectToCheckout({ sessionId: session.id });
    if (result.error) console.log(result.error);
  } catch (e) {
    console.log("stripe payment error", e);
  } finally {
    setDisablebutton(false);
  }
};

    const checkIfCareerIsChosen = () => {
      if (careername.length < 1) {
        showAlert("Please choose a career path first", "warning");
      } else {
        submitWebinarform();
      }
    };

  return (
    <div style={{ overflowX: "hidden" }}>
      <style>{`
:root {
  --gd: #1a4d2e;
  --gm: #2d6a4f;
  --gb: #3a9a5c;
  --gl: #d8f3dc;
  --gp: #f0faf2;
  --wh: #ffffff;
  --td: #1a2e1e;
  --tm: #5a7a62;
  --sh: rgba(26,77,46,0.13);
}
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}

body {
  background:var(--wh);
}

@keyframes blob{from{transform:translate(0,0) scale(1)}to{transform:translate(22px,18px) scale(1.06)}}

/* ── SCREEN WRAPPER ── */
.scene{position:relative;z-index:1;width:900px;max-width:95vw;min-height:520px}

.screen{
  display:flex;align-items:center;justify-content:center;
  transition:opacity .45s ease, transform .45s cubic-bezier(.22,1,.36,1);
}
.screen.out{opacity:0;pointer-events:none;transform:translateX(-40px) scale(.97)}
.screen.in-right{opacity:0;pointer-events:none;transform:translateX(40px) scale(.97)}

/* ══════════════════════════════
   SCREEN 1 — CHOOSE CAREER PATH
══════════════════════════════ */
.card{
  background:var(--wh);border-radius:28px;
  box-shadow:0 24px 80px var(--sh),0 4px 16px rgba(0,0,0,.05);
  width:85vw;max-width:95vw;display:grid;grid-template-columns:1fr 1fr;
  overflow:hidden;animation:rise .7s cubic-bezier(.22,1,.36,1) both;
}
@keyframes rise{from{opacity:0;transform:translateY(38px) scale(.97)}to{opacity:1;transform:none}}

/* left */
.s1-left{padding:52px 46px 52px 52px;display:flex;flex-direction:column;justify-content:center;gap:26px}
.badge{display:inline-flex;align-items:center;gap:8px;background:var(--gp);border:1px solid var(--gl);
  color:var(--gm);font-size:11.5px;font-weight:500;letter-spacing:.06em;text-transform:uppercase;
  padding:6px 14px;border-radius:100px;width:fit-content;animation:fu .5s .2s both}
.badge svg{width:14px;height:14px}
.heading{animation:fu .5s .3s both}
.heading h1{font-family:'Playfair Display',serif;font-size:34px;font-weight:700;color:var(--td);line-height:1.2}
.heading h1 em{color:var(--gb);font-style:normal}
.heading p{margin-top:11px;font-size:13.5px;color:var(--tm);line-height:1.7;font-weight:300}
.sel-group{animation:fu .5s .4s both}
.sel-lbl{display:block;font-size:11px;font-weight:500;letter-spacing:.07em;text-transform:uppercase;color:var(--tm);margin-bottom:9px}
.sel-wrap{position:relative}
select{width:100%;appearance:none;background:var(--gp);border:1.5px solid var(--gl);
  border-radius:14px;padding:14px 46px 14px 18px;font-family:'DM Sans',sans-serif;
  font-size:14.5px;color:var(--td);cursor:pointer;transition:border-color .2s,box-shadow .2s;outline:none}
select:focus{border-color:var(--gb);box-shadow:0 0 0 4px rgba(58,154,92,.12)}
select:hover{border-color:var(--gm)}
.sel-arr{position:absolute;right:15px;top:50%;transform:translateY(-50%);pointer-events:none;color:var(--gm)}
.chips{animation:fu .5s .5s both}
.chips-lbl{font-size:11px;font-weight:500;letter-spacing:.07em;text-transform:uppercase;color:var(--tm);margin-bottom:9px;display:block}
.chips-row{display:flex;flex-wrap:wrap;gap:7px}
.chip{background:var(--wh);border:1.5px solid var(--gl);color:var(--gm);font-family:'DM Sans',sans-serif;
  font-size:12px;font-weight:500;padding:5px 13px;border-radius:100px;cursor:pointer;
  transition:background .17s,border-color .17s,color .17s,transform .14s;white-space:nowrap}
.chip:hover{background:var(--gl);border-color:var(--gb);color:var(--gd);transform:translateY(-1px)}
.chip.active{background:var(--gm);border-color:var(--gm);color:var(--wh)}
.btn-apply{animation:fu .5s .6s both;width:100%;
  background:linear-gradient(135deg,var(--gm) 0%,var(--gd) 100%);
  color:var(--wh);border:none;border-radius:14px;padding:16px 28px;
  font-family:'DM Sans',sans-serif;font-size:15px;font-weight:500;cursor:pointer;
  display:flex;align-items:center;justify-content:center;gap:9px;
  transition:transform .2s,box-shadow .2s,filter .2s;
  box-shadow:0 8px 24px rgba(26,77,46,.28);letter-spacing:.02em}
.btn-apply:hover{transform:translateY(-2px);box-shadow:0 14px 32px rgba(26,77,46,.36);filter:brightness(1.08)}
.btn-apply:active{transform:none}
.btn-apply svg{width:17px;height:17px;transition:transform .2s}
.btn-apply:hover svg{transform:translateX(4px)}
@keyframes fu{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:none}}

/* right */
.s1-right{position:relative;background:var(--gd);overflow:hidden;min-height:500px;
  display:flex;flex-direction:column;justify-content:flex-end}
.s1-right img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:.44;mix-blend-mode:luminosity}
.s1-right::before{content:'';position:absolute;top:-70px;right:-70px;width:260px;height:260px;
  border:44px solid rgba(255,255,255,.05);border-radius:50%;z-index:1}
.s1-right::after{content:'';position:absolute;bottom:20px;right:-50px;width:180px;height:180px;
  border:32px solid rgba(58,154,92,.14);border-radius:50%;z-index:1}
.r-overlay{position:relative;z-index:2;padding:34px;
  background:linear-gradient(0deg,rgba(10,36,18,.9) 0%,rgba(10,36,18,.28) 60%,transparent 100%)}
.r-tag{display:inline-block;background:rgba(58,154,92,.24);border:1px solid rgba(58,154,92,.44);
  color:#a8e6c0;font-size:10.5px;font-weight:500;letter-spacing:.09em;text-transform:uppercase;
  padding:5px 12px;border-radius:100px;margin-bottom:14px}
.s1-right h2{font-family:'Playfair Display',serif;font-size:26px;color:var(--wh);line-height:1.25;font-weight:600;margin-bottom:9px}
.s1-right p{font-size:13px;color:rgba(255,255,255,.58);line-height:1.65;font-weight:300}
.stats{display:flex;gap:26px;margin-top:22px;padding-top:18px;border-top:1px solid rgba(255,255,255,.1)}
.stat .num{font-family:'Playfair Display',serif;font-size:22px;color:var(--wh);font-weight:700}
.stat .lbl{font-size:10.5px;color:rgba(255,255,255,.44);letter-spacing:.05em;text-transform:uppercase;margin-top:2px}


/* ══════════════════════════════
   SCREEN 2 — ENROLL / PAYMENT
══════════════════════════════ */
.enroll-card{
  background:var(--wh);border-radius:28px;
  box-shadow:0 24px 80px var(--sh),0 4px 16px rgba(0,0,0,.05);
  width:85vw;max-width:95vw;display:grid;grid-template-columns:1fr 1.1fr;overflow:hidden;
}

/* enroll left */
.e-left{background:var(--gp);padding:46px 38px;display:flex;flex-direction:column;
  justify-content:center;gap:22px;position:relative;overflow:hidden}
.e-left::before{content:'';position:absolute;bottom:-60px;left:-55px;width:200px;height:200px;
  background:radial-gradient(circle,var(--gl) 0%,transparent 70%);border-radius:50%;z-index:0}
.e-left>*{position:relative;z-index:1}
.back-btn{display:inline-flex;align-items:center;gap:6px;background:none;
  border:1.5px solid var(--gl);color:var(--gm);font-family:'DM Sans',sans-serif;
  font-size:12px;font-weight:500;padding:7px 14px;border-radius:100px;cursor:pointer;
  width:fit-content;transition:background .18s,border-color .18s,color .18s}
.back-btn:hover{background:var(--gl);border-color:var(--gb);color:var(--gd)}
.back-btn svg{width:13px;height:13px}
.e-left h2{font-family:'Playfair Display',serif;font-size:26px;font-weight:700;color:var(--td);line-height:1.25}
.e-left h2 em{color:var(--gb);font-style:normal}
.e-left .sub{font-size:13px;color:var(--tm);line-height:1.65;font-weight:300}

/* SVG illustration */
.illus{width:100%;max-width:220px;margin:0 auto;display:block}

/* selected course pill */
.course-pill{background:var(--wh);border:1.5px solid var(--gl);border-radius:16px;
  padding:13px 16px;gap:12px;
  box-shadow:0 4px 14px rgba(26,77,46,.07)}
.cp-icon{width:38px;height:38px;background:linear-gradient(135deg,var(--gm),var(--gd));
  border-radius:11px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.cp-icon svg{width:18px;height:18px;color:#fff}
.cp-name{font-size:13.5px;font-weight:600;color:var(--td)}
.cp-meta{font-size:11.5px;color:var(--tm);margin-top:2px}

/* features list */
.features{display:flex;flex-direction:column;gap:9px}
.feat{display:flex;align-items:center;gap:9px;font-size:12.5px;color:var(--tm)}
.feat svg{width:16px;height:16px;color:var(--gb);flex-shrink:0}

/* enroll right */
.e-right{padding:42px 38px;display:flex;flex-direction:column;justify-content:center;gap:20px}
.sec-lbl{font-size:10.5px;font-weight:500;letter-spacing:.08em;text-transform:uppercase;color:var(--tm)}

/* amount card */
.amt-card{background:linear-gradient(135deg,var(--gm) 0%,var(--gd) 100%);
  border-radius:20px;padding:24px 24px 20px;position:relative;overflow:hidden}
.amt-card::before{content:'';position:absolute;top:-38px;right:-38px;width:120px;height:120px;
  border:26px solid rgba(255,255,255,.07);border-radius:50%}
.amt-card::after{content:'';position:absolute;bottom:-26px;left:16px;width:88px;height:88px;
  border:17px solid rgba(255,255,255,.05);border-radius:50%}
.amt-lbl{font-size:10.5px;font-weight:500;letter-spacing:.1em;text-transform:uppercase;
  color:rgba(255,255,255,.58);margin-bottom:5px;position:relative}
.amt-val{font-family:'Playfair Display',serif;font-size:42px;font-weight:700;color:var(--wh);
  line-height:1;position:relative}
.amt-val sup{font-size:18px;vertical-align:super;font-family:'DM Sans',sans-serif;font-weight:400;opacity:.75}
.amt-sub{font-size:11.5px;color:rgba(255,255,255,.48);margin-top:5px;position:relative}

/* payment methods */
.pay-title{font-size:11.5px;font-weight:500;letter-spacing:.06em;text-transform:uppercase;
  color:var(--tm);margin-bottom:2px}
.pay-methods{display:flex;flex-direction:column;gap:9px}
.pay-method{background:var(--gp);border:2px solid var(--gl);border-radius:14px;
  padding:12px 15px;display:flex;align-items:center;justify-content:space-between;
  cursor:pointer;transition:border-color .2s,background .2s,box-shadow .2s;user-select:none}
.pay-method:hover{border-color:var(--gb);background:#ebf7ed}
.pay-method.selected{border-color:var(--gm);box-shadow:0 0 0 3px rgba(45,106,79,.12);background:var(--wh)}
.pm-left{display:flex;align-items:center;gap:11px}
.pm-logo{height:22px;width:auto;object-fit:contain}
.pm-name{font-size:13.5px;font-weight:600;color:var(--td)}
.pm-desc{font-size:11px;color:var(--tm);margin-top:1px}
.radio{width:18px;height:18px;border-radius:50%;border:2px solid var(--gl);flex-shrink:0;
  display:flex;align-items:center;justify-content:center;transition:border-color .2s}
.pay-method.selected .radio{border-color:var(--gm)}
.radio-dot{width:8px;height:8px;border-radius:50%;background:var(--gm);
  transform:scale(0);transition:transform .2s cubic-bezier(.34,1.56,.64,1)}
.pay-method.selected .radio-dot{transform:scale(1)}

/* paystack wordmark inline SVG colours */
.ps-blue{color:#00c3f7}

/* pay now button */
.btn-pay{width:100%;background:linear-gradient(135deg,var(--gm) 0%,var(--gd) 100%);
  color:var(--wh);border:none;border-radius:14px;padding:15px 28px;
  font-family:'DM Sans',sans-serif;font-size:15px;font-weight:500;cursor:pointer;
  display:flex;align-items:center;justify-content:center;gap:9px;
  transition:transform .2s,box-shadow .2s,filter .2s;
  box-shadow:0 8px 22px rgba(26,77,46,.28);letter-spacing:.02em}
.btn-pay:hover{transform:translateY(-2px);box-shadow:0 14px 30px rgba(26,77,46,.36);filter:brightness(1.08)}
.btn-pay:active{transform:none}
.btn-pay svg{width:17px;height:17px}
.secure-note{display:flex;align-items:center;gap:6px;font-size:11.5px;color:var(--tm);justify-content:center}
.secure-note svg{width:13px;height:13px;color:var(--gb)}

/* ── SUCCESS overlay ── */
.success-overlay{
  position:fixed;inset:0;z-index:999;
  background:rgba(10,36,18,.55);backdrop-filter:blur(6px);
  display:flex;align-items:center;justify-content:center;
  opacity:0;pointer-events:none;transition:opacity .35s}
.success-overlay.show{opacity:1;pointer-events:all}
.success-box{background:var(--wh);border-radius:24px;padding:44px 40px;text-align:center;
  max-width:360px;width:90%;box-shadow:0 24px 60px rgba(0,0,0,.18);
  transform:scale(.85) translateY(20px);transition:transform .4s cubic-bezier(.22,1,.36,1)}
.success-overlay.show .success-box{transform:none}
.tick-circle{width:72px;height:72px;border-radius:50%;
  background:linear-gradient(135deg,var(--gm),var(--gd));
  display:flex;align-items:center;justify-content:center;margin:0 auto 20px;
  box-shadow:0 10px 28px rgba(26,77,46,.28)}
.tick-circle svg{width:34px;height:34px;color:#fff}
.success-box h3{font-family:'Playfair Display',serif;font-size:24px;font-weight:700;color:var(--td);margin-bottom:10px}
.success-box p{font-size:13.5px;color:var(--tm);line-height:1.65}
.success-box .course-name{display:inline-block;margin-top:12px;background:var(--gp);
  border:1px solid var(--gl);color:var(--gm);font-size:13px;font-weight:600;
  padding:7px 18px;border-radius:100px}

/* ── RESPONSIVE ── */
@media(max-width:680px){
  .card,.enroll-card{grid-template-columns:1fr}
  .s1-right{min-height:200px}
  .e-left,.s1-left{padding:32px 24px}
  .e-right{padding:28px 24px}
  .heading h1{font-size:26px}
}
  `}

</style>
      <Modal show={showModal} onHide={handleModalClose} centered={true}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex justify-center items-center align-center text-center p-2">
            <BsEmojiFrown
              size={50}
              color="#047E35"
              className="flex justify-center items-center "
            />
          </div>

          <div>{modalContent}</div>
        </Modal.Body>
      </Modal>
      {/* <ToastContainer autoClose={2000} /> */}
      {ready ? (
        <>
          <Header />

          <div
            className="container"
            id="formsec"
            style={{ marginTop: "50px" }}
          >
            {showPaybutton ? (
              <>
                <div className="screen" id="s2">
    <div className="enroll-card">

      <div className="e-left">
        <button className="back-btn" id="back-btn" onClick={() => setShowPaybutton(false)}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
          Go Back
        </button>

        <div>
          <h2>Unlock Your <em>Potential:</em><br />Enroll Today!</h2>
          <p className="sub" style={{marginTop: "10px"}}>Take the First Step Towards Your Bright Future</p>
        </div>

        {/* <svg className="illus" viewBox="0 0 280 180" fill="none" xmlns="http://www.w3.org/2000/svg">
          
          <rect x="20" y="130" width="80" height="6" rx="3" fill="#2d6a4f" opacity=".25"/>
          <rect x="45" y="136" width="8" height="28" rx="2" fill="#2d6a4f" opacity=".2"/>
          <rect x="67" y="136" width="8" height="28" rx="2" fill="#2d6a4f" opacity=".2"/>
          <rect x="160" y="120" width="100" height="6" rx="3" fill="#2d6a4f" opacity=".25"/>
          <rect x="180" y="126" width="8" height="38" rx="2" fill="#2d6a4f" opacity=".2"/>
          <rect x="230" y="126" width="8" height="38" rx="2" fill="#2d6a4f" opacity=".2"/>
          
          
          <rect x="30" y="114" width="36" height="22" rx="3" fill="#3a9a5c" opacity=".35"/>
          <rect x="26" y="136" width="44" height="3" rx="1.5" fill="#2d6a4f" opacity=".3"/>
          
          <rect x="168" y="96" width="52" height="34" rx="4" fill="#3a9a5c" opacity=".3"/>
          <rect x="188" y="130" width="12" height="6" rx="1" fill="#2d6a4f" opacity=".25"/>
          <rect x="178" y="136" width="32" height="3" rx="1.5" fill="#2d6a4f" opacity=".25"/>
          
          <ellipse cx="60" cy="108" rx="13" ry="13" fill="#d8f3dc"/>
          <path d="M47 130 Q60 118 73 130" stroke="#1a4d2e" stroke-width="2" fill="#d8f3dc"/>
          <line x1="60" y1="121" x2="52" y2="134" stroke="#1a4d2e" stroke-width="2" stroke-linecap="round"/>
          <line x1="60" y1="121" x2="68" y2="130" stroke="#1a4d2e" stroke-width="2" stroke-linecap="round"/>
          
          <ellipse cx="140" cy="62" rx="14" ry="14" fill="#b7e4c7"/>
          <path d="M126 88 Q140 74 154 88 L154 125 Q140 130 126 125Z" fill="#b7e4c7"/>
          <line x1="126" y1="95" x2="112" y2="108" stroke="#2d6a4f" stroke-width="2.5" stroke-linecap="round"/>
          <line x1="154" y1="95" x2="164" y2="115" stroke="#2d6a4f" stroke-width="2.5" stroke-linecap="round"/>
          <line x1="132" y1="125" x2="132" y2="160" stroke="#1a4d2e" stroke-width="2.5" stroke-linecap="round"/>
          <line x1="148" y1="125" x2="148" y2="160" stroke="#1a4d2e" stroke-width="2.5" stroke-linecap="round"/>
      
          <rect x="90" y="30" width="100" height="58" rx="5" fill="#f0faf2" stroke="#3a9a5c" stroke-width="1.5"/>
          <line x1="102" y1="48" x2="162" y2="48" stroke="#3a9a5c" stroke-width="1.5" opacity=".5"/>
          <line x1="102" y1="58" x2="150" y2="58" stroke="#3a9a5c" stroke-width="1.5" opacity=".4"/>
          <line x1="102" y1="68" x2="140" y2="68" stroke="#3a9a5c" stroke-width="1.5" opacity=".3"/>
       
          <ellipse cx="210" cy="100" rx="13" ry="13" fill="#d8f3dc"/>
          <path d="M197 122 Q210 110 223 122" stroke="#1a4d2e" stroke-width="2" fill="#d8f3dc"/>
          <line x1="210" y1="113" x2="200" y2="126" stroke="#1a4d2e" stroke-width="2" stroke-linecap="round"/>
          <line x1="210" y1="113" x2="220" y2="124" stroke="#1a4d2e" stroke-width="2" stroke-linecap="round"/>
        </svg> */}
        <img src="../../images/enrolloneimg.png" alt="enroll" />

        <div className="course-pill" id="course-pill">
          <div className="cp-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/>
            </svg>
          </div>
          <div>
            <div className="cp-name" id="cp-name">

              {isNigerianIP ? (
                    <>
                      
                            {careername}
                        
                    </>
                  ) : (
                    <>
                      
                            {careername}
                         
                    </>
                  )}
            </div>
            <div className="cp-meta">Full programme · 6 months</div>
          </div>
        </div>

        <div className="features">
          <div className="feat">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            Lifetime access to course materials
          </div>
          <div className="feat">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            Certificate upon completion
          </div>
          <div className="feat">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            Mentorship &amp; career support
          </div>
        </div>
      </div>
      <div className="e-right">

        <div>
          <div className="sec-lbl">Course Fee</div>
          <div className="amt-card">
            <div className="amt-lbl">Total Payment</div>
            <div className="amt-val">{isNigerianIP ? (
                    <>
                      
                            {careerprice}
                        
                    </>
                  ) : (
                    <>
                      
                           {careerprice}
                         
                    </>
                  )}</div>
            <div className="amt-sub">One-time payment · No hidden fees</div>
          </div>
        </div>

        <div>
          <div className="pay-title" style={{marginBottom: "12px"}}>Select Payment Method</div>
          <div className="pay-methods">
                  {isNigerianIP ? (
                    <>
                      
                            <PaystackHookExample />
                        
                    </>
                  ) : (
                    <>
                      
                            <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        background: "#277a8f",
                                        padding: "9px",
                                        borderRadius: "10px",
                                        cursor: "pointer",
                                        textAlign: "center",
                                        marginTop: "10px",
                                        color: "#ffffff",
                                        fontSize: "17px",
                                      }}
                                      onClick={() => {
                                        makePaymentWithStripe();
                                      }}
                                    >
                                      <div style={{display: "flex"}}>
                                        Pay Now with{" "}
                                        <img
                                          src="../../images/Stripepay.png"
                                          alt="stripe"
                                        />

                                      </div>
                                      
                                    </div>
                         
                    </>
                  )}
               
            {/* <div className="pay-method selected" data-method="paystack">
              <div className="pm-left">
                <svg viewBox="0 0 90 24" width="82" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="22" height="22" rx="4" fill="#00c3f7" y="1"/>
                  <rect x="4" y="5" width="14" height="3" rx="1.5" fill="white"/>
                  <rect x="4" y="10.5" width="14" height="3" rx="1.5" fill="white"/>
                  <rect x="4" y="16" width="9" height="3" rx="1.5" fill="white"/>
                  <text x="28" y="17" font-family="DM Sans,sans-serif" font-weight="700" font-size="13" fill="#011B33">pay</text>
                  <text x="52" y="17" font-family="DM Sans,sans-serif" font-weight="700" font-size="13" fill="#00c3f7">stack</text>
                </svg>
                <div>
                  <div className="pm-name">Paystack</div>
                  <div className="pm-desc">Card, bank transfer, USSD</div>
                </div>
              </div>
             
            </div> */}

            {/* <div className="pay-method" data-method="flutterwave">
              <div className="pm-left">
                <svg viewBox="0 0 90 24" width="82" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="22" height="22" rx="4" fill="#f5a623" y="1"/>
                  <path d="M5 12 Q11 6 17 12 Q11 18 5 12Z" fill="white"/>
                  <text x="28" y="17" font-family="DM Sans,sans-serif" font-weight="700" font-size="12" fill="#1a1a1a">Flutterwave</text>
                </svg>
                <div>
                  <div className="pm-name">Flutterwave</div>
                  <div className="pm-desc">Card, mobile money</div>
                </div>
              </div>
              <div className="radio"><div className="radio-dot"></div></div>
            </div> */}

            {/* <div className="pay-method" data-method="bank">
              <div className="pm-left">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#2d6a4f" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="2" y="8" width="20" height="13" rx="2"/><path d="M6 8V6a6 6 0 0 1 12 0v2"/><line x1="12" y1="13" x2="12" y2="16"/>
                </svg>
                <div>
                  <div className="pm-name">Bank Transfer</div>
                  <div className="pm-desc">Direct bank payment</div>
                </div>
              </div>
              <div className="radio"><div className="radio-dot"></div></div>
            </div> */}

          </div>
        </div>

        {/* <button className="btn-pay" id="pay-btn" >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/>
          </svg>
          Proceed to Payment
        </button> */}

        <div className="secure-note">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          </svg>
          Secured by 256-bit SSL encryption
        </div>

      </div>
    </div>
  </div>
              </>
            ) : (
              <>

              <div className="screen" id="s1">
    <div className="card">

      <div className="s1-left">
        <div className="badge">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/>
          </svg>
          Career Explorer
        </div>

        <div className="heading">
          <h1>Find Your <em>Perfect</em><br/>Career Path</h1>
          <p>Select a field that excites you and take the first step towards a rewarding future in tech and business.</p>
        </div>

        <div className="sel-group">
          <label className="sel-lbl" >Choose Career Path</label>
          <div className="sel-wrap">
             
            <select id="career-select" value={careerValue}
                 onChange={(e) => {
                  const v = e.target.value;
                  setCareerValue(v)
                  handleCareerpathClick(
                                        v,
                                        sCareerPriceList[sCareerPathList.indexOf(v)]
                                      )
                  
                 }}>
                  <option value="" disabled selected>Select a path…</option>
                  {careerpath.map((item: any) => (
                                  <option value={item.Careerpath} >{item.Careerpath}</option>
                                  
                              ))}
              
              {/* <option value="software-testing">Software Testing</option>
              <option value="product-design">Product Design</option>
              <option value="marketing">Marketing</option>
              <option value="product-management">Product Management</option>
              <option value="software-engineering">Software Engineering</option>
              <option value="cyber-security">Cyber Security</option>
              <option value="data-science">Data Analytics</option> */}
            </select>

            {showcarerror ? (
                            <>
                              <p
                                className={
                                  showcarerror ? "errortext2" : "errortext3"
                                }
                              >
                                Please choose a career path
                              </p>
                            </>
                          ) : (
                            <></>
                          )}

                        {showprice ? (
                          <>
                            <div>
                              <div
                                style={{
                                  fontSize: "18px",
                                  color: "#156614",
                                }}
                              >
                                Here is your charge:{" "}
                                <span style={{ fontWeight: "500" }}>
                                  {careerprice}
                                </span>
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
            <span className="sel-arr">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
            </span>
          </div>
        </div>

        <div className="chips">
          <span className="chips-lbl">Quick pick</span>
          <div className="chips-row" id="chips-row">
            <button className={`chip  ${careerValue === "Software Engineering" ? "active":""}`} data-value="software-engineering" onClick={() => {setCareerValue("Software Engineering")
                  handleCareerpathClick(
                                        "Software Engineering",
                                        sCareerPriceList[sCareerPathList.indexOf("Software Engineering")]
                                      )
                  }}>Engineering</button>
            <button className={`chip  ${careerValue === "Data Analytics" ? "active":""}`} data-value="data-science" onClick={() => {setCareerValue("Data Analytics")
                  handleCareerpathClick(
                                        "Data Analytics",
                                        sCareerPriceList[sCareerPathList.indexOf("Data Analytics")]
                                      )
                  }}>Data Analytics</button>
            <button className={`chip  ${careerValue === "Product Design" ? "active":""}`} data-value="product-design" onClick={() => {setCareerValue("Product Design")
                  handleCareerpathClick(
                                        "Product Design",
                                        sCareerPriceList[sCareerPathList.indexOf("Product Design")]
                                      )
                  }}>Design</button>
            <button className={`chip  ${careerValue === "Cyber Security" ? "active":""}`} data-value="cyber-security" onClick={() => {setCareerValue("Cyber Security")
                  handleCareerpathClick(
                                        "Cyber Security",
                                        sCareerPriceList[sCareerPathList.indexOf("Cyber Security")]
                                      )
                  }}>Security</button>
            <button className={`chip  ${careerValue === "Marketing" ? "active":""}`} data-value="marketing" onClick={() => {setCareerValue("Marketing")
                  handleCareerpathClick(
                                        "Marketing",
                                        sCareerPriceList[sCareerPathList.indexOf("Marketing")]
                                      )
                  }}>Marketing</button>

            <button className={`chip  ${careerValue === "Product Management" ? "active":""}`} data-value="product-management" onClick={() => {setCareerValue("Product Management")
                  handleCareerpathClick(
                                        "Product Management",
                                        sCareerPriceList[sCareerPathList.indexOf("Product Management")]
                                      )
                  }}>Management</button>
            <button className={`chip  ${careerValue === "Software Testing" ? "active":""}`} data-value="software-testing" onClick={() => {setCareerValue("Software Testing")
                  handleCareerpathClick(
                                        "Software Testing",
                                        sCareerPriceList[sCareerPathList.indexOf("Software Testing")]
                                      )
                  }}>Testing</button>
          </div>
        </div>

        <button className="btn-apply" id="apply-btn" disabled={disablebutton}  onClick={() => checkIfCareerIsChosen()}>
          Apply Now
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
          </svg>
        </button>
      </div>

      <div className="s1-right">
        {/* <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80" alt="" /> */}
        <div className="r-overlay">
          <span className="r-tag">✦ Launch Your Journey</span>
          <h2>Shape the Future<br />with Your Skills</h2>
          <p>Thousands of professionals have transformed their careers with the right path and focused guidance.</p>
          <div className="stats">
            <div className="stat"><div className="num">7+</div><div className="lbl">Career Paths</div></div>
            <div className="stat"><div className="num">94%</div><div className="lbl">Success Rate</div></div>
            <div className="stat"><div className="num">12k</div><div className="lbl">Graduates</div></div>
          </div>
        </div>
      </div>

    </div>
  </div>
                {/* <div className="row">
                  <div className="col-md-6">
                    <div
                      className="card"
                      style={{ padding: "30px", marginBottom: "20px" }}
                    >
                      <Form onSubmit={checkIfCareerIsChosen}>
                       

                        <Form.Group className="mb-3">
                          <Dropdown
                            as={ButtonGroup}
                            className={
                              showcarerror ? "careerpaths2" : "careerpath2error"
                            }
                          >
                            <Button variant = "default"
                            onClick={(e) => {
                              const nextSibling = e.currentTarget.nextSibling;
                              if (nextSibling instanceof HTMLElement) {
                                  nextSibling.click();
                              }
                          }}>
                              Choose Career Path
                            </Button>
                            <Dropdown.Toggle
                              split
                              variant="default"
                              id="dropdown-split-basic"
                            />

                            <Dropdown.Menu>
                              {careerpath.map((item: any) => (
                                <div key={item.id} className="col-12">
                                  <Dropdown.Item
                                    key={item.Careerpath}
                                    onClick={() =>
                                      handleCareerpathClick(
                                        item.Careerpath,
                                        item.price
                                      )
                                    }
                                  >
                                    {item.Careerpath}
                                  </Dropdown.Item>
                                </div>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                          {showcarerror ? (
                            <>
                              <p
                                className={
                                  showcarerror ? "errortext2" : "errortext3"
                                }
                              >
                                Please choose a career path
                              </p>
                            </>
                          ) : (
                            <></>
                          )}
                        </Form.Group>
                        {showprice ? (
                          <>
                            <div>
                              <div
                                style={{
                                  fontSize: "18px",
                                  color: "#156614",
                                }}
                              >
                                Here is your charge:{" "}
                                <span style={{ fontWeight: "500" }}>
                                  {careerprice}
                                </span>
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}

                        <div className="row">
                          <div className="col-7"></div>
                          <div className="col-5">
                            <button
                              type="submit"
                              disabled={disablebutton}
                              className="btn btn-success interviewbtn"
                            >
                              Apply
                            </button>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div
                      style={{
                        position: "relative",
                        backgroundColor: "#156614",
                        height: "320px",
                        width: "100%",
                        marginBottom: "20px",
                        marginTop: "30px",
                      }}
                    >
                      <img
                        src="../../images/handsonform.png"
                        style={{
                          position: "absolute",
                          bottom: "30px",
                          left: "30px",
                          width: "100%",
                          height: "100%",
                        }}
                        alt="handsondetails"
                      />
                    </div>
                  </div>
                  <div className="col-md-1"></div>
                </div> */}
              </>
            )}
          </div>

          <br />
          <br />
          <br />

          <Footer />
        </>
      ) : (
        <>
          <div>
            <div className="academystyle">
              <img src="../../images/doyenifyAcademy.png" alt="doy academy" />
              <ClipLoader size={25} color="#047E35" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Handsonform;
